<template>
  <section>
    <b-modal width="680px" :active.sync="active">
    <div class="card" style="border-radius: 5px; padding: 16px;" v-if="sk">
        <h2 style="font-size: x-large; padding: 8px;">アクション履歴</h2>
        <table style="will-change: transform;" class="disp-scroll">
          <tr style="position: relative;">
            <th v-for="(t, i) in headers" :key="i">
              {{t}}
            </th>
          </tr>
          <tr style="max-height: 50px; min-height: 50px; height: 50px;" v-for="(act, index) in historyDesc" :key="index">
            <td>{{act.is_finished ? '完了' : '未完了'}}</td>
            <td>{{act.action_data.name}}</td>
            <td>{{new Date(act.created_at).toLocaleString('ja-JP')}}</td>
            <td>
              <template v-if="act.ended_at">{{new Date(act.ended_at).toLocaleString('ja-JP')}}</template>
              <template v-else>-</template>
            </td>
            <td>{{getStatus(act.finished_status)}}</td>
          </tr>
        </table>
      </div>
    </b-modal>
  </section>
</template>

<script>
export default {
  name: 'ModalActionTable',
  data () {
    return {
      active: false,
      sk: null,
      headers: [
        '結果',
        'アクション名',
        '指示日時',
        '完了日時',
        'ステータス'
      ]
    }
  },
  computed: {
    historyDesc () {
      return this.sk.recruitment_flow_action_history.slice().reverse()
    }
  },
  methods: {
    toggle () {
      this.active = true
    },
    getStatus (s) {
      if (!s) return '-'
      if (s === 0) return '予約状態'
      if (s === 1) return '正常終了'
      if (s === 9) return 'エラー'
    }
  }
}
</script>

<style lang='scss' scoped>

table td:not([align]), table th:not([align]) {
  text-align: center;
}
table {
  width: 100%;
  border-collapse:collapse;
  margin: 0 auto;
  display: block;
  height: 500px;
  table-layout: fixed;
}
td,th {
  min-width: 100px;
  padding: 8px;
  margin: auto;
  max-width: 350px;
  font-size: smaller;
}
td {
  text-align: left;
  padding: 8px;
}
th {
  background:#ffeeff;
  white-space: nowrap;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 10000;
  vertical-align: middle;
}
table tr:nth-child(odd) {
  background:#ffeeff;
}
table tr:nth-child(even) {
  background:#fafafa;
}

</style>



// WEBPACK FOOTER //
// src/views/DashBoard/Manage/ModalActionTable.vue